/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.SelfServePublicRpc
 */

import type {
  ChirpAvroRpcDetails,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type CollectionPreviewItem = {
  listingId: number;
  slug?: string;
  iconUrl?: string;
  name?: string;
};

export type CollectionWithPreviews = {
  id: number;
  title?: string;
  name: string;
  description: string;
  slug: string;
  tagline: string;
  itemCount: number;
  displayed: Default<boolean>;
  previewItems: Default<CollectionPreviewItem[]>;
  updatedAt?: number;
  htmlPageTitle: string;
  metaDescription: string;
};

export type CollectionsWithPreviewsResponse = {
  collections: Default<CollectionWithPreviews[]>;
};

export type GetAllPublishedCollectionsResponseType =
  CollectionsWithPreviewsResponse;
export type GetAllPublishedCollectionsErrorType = EmptyError & HubspotMetadata;
export const getAllPublishedCollectionsRpc: ChirpAvroRpcDetails<
  undefined,
  GetAllPublishedCollectionsResponseType,
  GetAllPublishedCollectionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.marketplace.quality.rpc.SelfServePublicRpc',
  rpcName: 'getAllPublishedCollections',
  auth: 'external',
  fingerprint: 'AAAAAAAAAAAGFx25esjAAZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
